import React from "react";
import ChannelIcon from "../ChannelIcon";

/**
 * ChannelBadge
 *
 * Phase 3.1 — Professional Channel Visibility
 *
 * Inline badge shown next to contact name in ticket header.
 * Uses official platform SVG icons via ChannelIcon.
 * Read-only, no click action.
 *
 * Props:
 *   channel: "whatsapp" | "facebook" | "instagram" | "email" | "telegram"
 */

const CHANNEL_CONFIG = {
  whatsapp:  { label: "WhatsApp",  bg: "#e8faf0", color: "#128c7e" },
  facebook:  { label: "Messenger", bg: "#e7f0fd", color: "#0062E0" },
  instagram: { label: "Instagram", bg: "#fce4ec", color: "#d6249f" },
  email:     { label: "Email",     bg: "#ede7f6", color: "#5C6BC0" },
  telegram:  { label: "Telegram",  bg: "#e1f5fe", color: "#0288d1" },
};

const ChannelBadge = ({ channel }) => {
  const config = CHANNEL_CONFIG[channel] || CHANNEL_CONFIG.whatsapp;

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: 5,
        background: config.bg,
        color: config.color,
        borderRadius: 12,
        padding: "2px 8px 2px 4px",
        fontSize: 11,
        fontWeight: 600,
        marginLeft: 8,
        verticalAlign: "middle",
        userSelect: "none",
        whiteSpace: "nowrap",
      }}
    >
      <ChannelIcon channel={channel} size={14} />
      {config.label}
    </span>
  );
};

export default ChannelBadge;
